export const HAS_VIEWER_COUNT = false;

export const HAS_SYNC = false;

export const HAS_STORE = false;

export const HAS_LOG = false;

export const HAS_FILE_EXPLORER = false;

export const HAS_SETTINGS = false;

export const HAS_NOTIFICATIONS = false;

export const HAS_FULLSCREEN = false;

export const HAS_MAP_EDITING = false;

export const HAS_MULTIPLE_VIEWS = false;

export const HAS_GPS = true;
